<template>
  <div class="trasfer">
    <card-layout>
      <template slot="image">
        <vehicle-image
          :src="card.vehicle.image"
          :alt="vehicleName"
          :rating="card.provider.rating"
        >
          {{ 'OR_SIMILAR' | i18n(locale) }}
        </vehicle-image>
      </template>

      <template slot="provider">
        <provider-info
          :category="card.vehicle.category"
        />
        <div>
          <provider-tag
            v-for="(tag, index) in card.tags"
            :key="index"
          >
            {{ tag.text.toUpperCase() }}
          </provider-tag>
        </div>
      </template>

      <capacity
        slot="capacity"
        :passengers="card.vehicle.max_passengers"
        :bags="card.vehicle.max_bags"
      />

      <template
        slot="cost"
      >
        {{ card.price.price.compact }}
      </template>

      <template slot="desktopCapacity">
        <service-list :services="card.amenities">
          <capacity
            :passengers="card.vehicle.max_passengers"
            :bags="card.vehicle.max_bags"
          />
        </service-list>
        <cancel-notice
          v-if="card.waitTime.minutes_included"
          :minutes="card.waitTime.minutes_included"
          :start="waitingTimeText.start"
        >
          {{ waitingTimeText.text }}
        </cancel-notice>
      </template>

      <template slot="services">
        <service-list :services="card.amenities" />
        <cancel-notice
          v-if="card.waitTime.minutes_included"
          :minutes="card.waitTime.minutes_included"
          :start="waitingTimeText.start"
        >
          {{ waitingTimeText.text }}
        </cancel-notice>
      </template>

      <transfer-meta slot="meta">
        <template
          v-if="isFreeCancel"
          slot="freeCancel"
        >
          {{ 'FREE_CANCEL' | i18n(locale) }}
        </template>
        <template slot="tax">
          {{ 'TAXES' | i18n(locale) }}
        </template>
      </transfer-meta>

      <button-order
        slot="buttonOrder"
        :trip-id="card.resultId"
        :locale="locale"
        v-bind="$attrs"
      >
        {{ 'BOOK_RIDE' | i18n(locale) }}
      </button-order>
    </card-layout>
  </div>
</template>

<script>
import { i18n as i18nFilter } from '../../vueFilters';

import VehicleImage from './components/VehicleImage';
import ProviderInfo from './components/ProviderInfo';
import ProviderTag from './components/ProviderTag';
import ServiceList from './components/ServiceList';
import Capacity from './components/Capacity';
import CancelNotice from './components/CancelNotice';
import Meta from './components/Meta';
import ButtonOrder from './components/ButtonOrder';
import CardLayout from './components/CardLayout';

export default {
  name: 'MozTransfertCard',
  components: {
    VehicleImage,
    ProviderInfo,
    ProviderTag,
    ServiceList,
    Capacity,
    CancelNotice,
    TransferMeta: Meta,
    ButtonOrder,
    CardLayout,
  },
  filters: {
    i18n: i18nFilter,
  },
  props: {
    /**
     * Результат @src/modules/Mozio/services/mozio/normalizer.js::convertToFlat
     */
    card: {
      type: Object,
      required: true,
    },
    locale: {
      type: String,
      required: false,
      default: 'en',
    },
  },
  computed: {
    isFreeCancel() {
      return this.card.cancellation.cancellable_online
        && this.card.cancellation.cancellable_offline;
    },
    waitingTimeText() {
      const text = this.$options.filters.i18n('FREE_WAITING', this.locale);
      return {
        start: text.indexOf('%time%') === 0,
        text: text.replace('%time%', ''),
      };
    },
    vehicleName() {
      return `${this.card.vehicle.make} ${this.card.vehicle.model}`;
    },
  },
};
</script>

<style lang="scss" scoped>

  .trasfer {
    border-radius: 4px;
    border: solid 1px #e6e6e6;
    background-color: #fff;
    padding: 28px 24px;
    display: flex;
    flex-direction: column;
    // max-width: 320px;
    box-sizing: border-box;
  }

  ul {
    list-style: none;
  }
</style>
